<template>
    <!-- 产品单位列表 -->
    <vProductUnitListComponent :postList="postList" v-if="flag"></vProductUnitListComponent>
</template>
<script>
import vProductUnitListComponent from '../../listComponent/basicdata/product/productUnitComponent.vue';
export default {
    name: 'productUnitList',
    components: {
        vProductUnitListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                rid:true,
                updateBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>